import { define, type, auto, Record, Collection } from 'type-r'

import PowerDate from '#metatypes/power_date.js'
import ValidRecord from './valid_record';
import DOB from '#metatypes/dob.js';

@define 
export class TypeWhenCollection<R extends TypeWhenRecord = TypeWhenRecord> extends Collection<R> {

}

@define 
export class TypeWhenRecord extends ValidRecord {
    static Collection = TypeWhenCollection<TypeWhenRecord>;
    @(type(String).as) type: string
    @(type(String).as) when: string

}
